import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  stepItem: {
    display: 'flex',
    alignItems: 'stretch',
  },
  iconColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    marginRight: theme.spacing(0.5),
  },
  iconWrapper: {
    width: 16,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  connector: {
    width: 1,
    flex: '1 1 auto',
    minHeight: 6,
    backgroundColor: theme.palette.divider,
    marginTop: 2,
    marginBottom: 2,
  },
  stepIcon: {
    color: theme.palette.text.disabled,
    display: 'block',
  },
  spinner: {
    color: theme.palette.text.disabled,
  },
  stepContent: {
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(0.25),
  },
  stepLabel: {
    fontSize: 13,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
}))

export default styles
